var map = {
	"./ar.json": "a54f",
	"./az.json": "e877",
	"./ba.json": "6fb3",
	"./de.json": "2508",
	"./en.json": "e088",
	"./es.json": "d90a",
	"./et.json": "8d87",
	"./fa.json": "12fa",
	"./fi.json": "86a4",
	"./fr.json": "2394",
	"./hr.json": "1825",
	"./hu.json": "cebc",
	"./id.json": "9e03",
	"./it.json": "06b7",
	"./ja.json": "19d0",
	"./nl.json": "674d",
	"./pl.json": "b890",
	"./pt.json": "6a7b",
	"./ro.json": "0e0b",
	"./ru.json": "626a",
	"./sl.json": "abfd",
	"./sr.json": "0367",
	"./tr.json": "9237",
	"./zh-tw.json": "1331",
	"./zh.json": "8066"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6cd2";